import type { TourDefinition } from '../tours.types';


export const MODAL_ASSOCIATE_GROUPS_TOUR: TourDefinition = {
  id: 'modal_associate_groups_help',
  route: '/perfil/perfil',
  remember: true,
  steps: [
    {
      element: '[data-tour="modal-grupos-title"]',
      popover: {
        title: 'Asignar grupos',
        description:
          'Aquí puedes asociarte a los grupos de tu empresa para participar en procesos de firma grupales.',
        side: 'bottom',
        align: 'start',
      },
    },

    {
      element: '[data-tour="modal-grupos-selector"]',
      popover: {
        title: 'Selecciona un grupo',
        description:
          'Busca y selecciona el grupo al que perteneces. ' +
          'Los grupos están organizados de forma jerárquica, por lo que puedes expandirlos para encontrar subgrupos.',
        side: 'bottom',
        align: 'start',
      },
    },

    {
      element: '[data-tour="modal-grupos-asignar"]',
      popover: {
        title: 'Asignar grupo',
        description:
          'Después de seleccionar un grupo, haz clic aquí para asociarlo a tu certificado.',
        side: 'left',
        align: 'center',
      },
    },

    {
      element: '[data-tour="modal-grupos-tabla"]',
      popover: {
        title: 'Grupos asignados',
        description:
          'Aquí verás los grupos que ya tienes asociados. ' +
          'Puedes eliminar una asignación cuando lo necesites.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
